import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { profile } from "../data/profile";
import "../contact-resume.css";

export function ResumeDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const panel = useRef<HTMLDivElement>(null);
  const closeButton = useRef<HTMLButtonElement>(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open) return;
    const opener = document.activeElement as HTMLElement | null;
    const previousOverflow = document.body.style.overflow;
    const background = Array.from(
      document.getElementById("root")?.children || []
    ).filter((element) => element instanceof HTMLElement) as HTMLElement[];
    const previousInert = background.map((element) =>
      element.hasAttribute("inert")
    );
    background.forEach((element) => element.setAttribute("inert", ""));
    document.body.style.overflow = "hidden";
    closeButton.current?.focus();
    function handleKey(event: KeyboardEvent) {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        close.current();
      }
      if (event.key !== "Tab") return;
      const items = Array.from(
        panel.current?.querySelectorAll<HTMLElement>(
          'a[href],button:not([disabled]),[tabindex="0"]'
        ) || []
      );
      const first = items[0],
        last = items[items.length - 1];
      if (
        event.shiftKey &&
        (document.activeElement === first ||
          document.activeElement === panel.current)
      ) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
    document.addEventListener("keydown", handleKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      background.forEach((element, index) => {
        if (!previousInert[index]) element.removeAttribute("inert");
      });
      document.removeEventListener("keydown", handleKey);
      if (opener?.isConnected && !opener.closest("[hidden]")) opener.focus();
      else
        document
          .querySelector<HTMLButtonElement>(".portfolio-resume-trigger")
          ?.focus();
    };
  }, [open]);
  if (!open) return null;
  return createPortal(
    <div
      className="resume-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="resume-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="resume-title"
        aria-describedby="resume-description"
        ref={panel}
        tabIndex={-1}
      >
        <header className="resume-toolbar">
          <span className="micro">THE PROFESSIONAL OVERVIEW</span>
          <button
            ref={closeButton}
            className="resume-close"
            onClick={onClose}
            aria-label="Close résumé"
          >
            Close <span aria-hidden="true">×</span>
          </button>
        </header>
        <div className="resume-content">
          <h2 id="resume-title">Kevin Hernandez-Nino</h2>
          <p id="resume-description">Computer engineer · Résumé</p>
          <div className="resume-actions">
            <a
              className="action-link"
              href={profile.resume}
              target="_blank"
              rel="noreferrer"
            >
              Open PDF <span aria-hidden="true">↗</span>
            </a>
            <a
              className="action-link action-link-primary"
              href={profile.resume}
              download="Kevin-Hernandez-Nino-Resume.pdf"
            >
              Download PDF <span aria-hidden="true">↓</span>
            </a>
          </div>
          <a
            className="resume-page"
            href={profile.resume}
            target="_blank"
            rel="noreferrer"
            aria-label="Open the full-size résumé PDF"
          >
            <img
              src="/images/resume-preview.png"
              width="1391"
              height="1800"
              alt="One-page résumé for Kevin Hernandez-Nino, including education, professional experience, skillset, and software projects."
            />
          </a>
        </div>
      </div>
    </div>,
    document.body
  );
}
